import type { MessageInfoSchemaType } from '..';

enum MessageWindowBoundary {
  OLDER = 'older',
  NEWER = 'newer',
}

type MessageWindowBoundaryState = {
  cursor: string | null;
  hasMore: boolean;
};

type MessageWindowBoundaries = Record<MessageWindowBoundary, MessageWindowBoundaryState>;

type MessageWindowSnapshot = {
  boundaries: MessageWindowBoundaries;
  messages: MessageInfoSchemaType[];
};

export {
  MessageWindowBoundary,
  type MessageWindowBoundaries,
  type MessageWindowBoundaryState,
  type MessageWindowSnapshot,
};
